/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import * as types from '../types'

const user = (state = {}, action) => {
  switch (action.type) {
    case types.user.SET_USER:
      return action.res
    case types.user.SET_USER_BY_ID:
      return { ...state, userById: action.user }
    default:
      return state
  }
}

export default user
